import React, { useState } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { EditNotesDialog } from './EditNotesDialog';
import { editButtonOffsetSx } from '../../App';

interface MemberNotesProps {
  notes?: string | null;
  editMode: boolean;
  onSaveNotes?: (notes: string) => void;
}

export const MemberNotes: React.FC<MemberNotesProps> = ({ notes, editMode, onSaveNotes }) => {
  const [isEditNotesOpen, setIsEditNotesOpen] = useState(false);

  return (
    <Box sx={{ flex: 1, mt: 1 }}>
      <Box
        sx={{
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Notes
          </Typography>
          {editMode && onSaveNotes && (
            <IconButton size="small" sx={editButtonOffsetSx} onClick={() => setIsEditNotesOpen(true)}>
              <EditIcon  />
            </IconButton>
          )}
        </Stack>
      </Box>
      <Typography variant="body2">{notes || '-'}</Typography>
      <EditNotesDialog
        open={isEditNotesOpen}
        label="Notes"
        initialValue={notes ?? ''}
        onClose={() => setIsEditNotesOpen(false)}
        onSave={(newNotes) => {
          onSaveNotes?.(newNotes);
          setIsEditNotesOpen(false);
        }}
      />
    </Box>
  );
};
